import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";


export class DateRangePickerDialogViewComponent implements IController {

  model: any;

  constructor(private moment) {
  }

  isDisableDate(date) {
    return (this.model.min ? this.moment(date).isBefore(this.moment(this.model.min)) : false) ||
      (this.model.max ? this.moment(date).isAfter(this.moment(this.model.max)) : false);
  }

}

angular
  .module('bringoz.admin.commons')
  .component('dateRangePickerDialogView', {
    bindings: {
      model: '<'
    },
    templateUrl: 'app/modules/commons/components/date-range-picker-dialog-view/date-range-picker-dialog-view.html',
    controller: DateRangePickerDialogViewComponent
  });
